/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

// @ts-ignore
import {GetLocalText,GenerateProductAssetUrl} from "./../../themes/kent/utilities/functions";
// @ts-ignore
import {GeneralAssetUrl} from "./../../themes/kent/utilities/constants";

interface IState {
  product?:any;
  images?:any;
  imageLoaded?:any;
  selectedIndex?:any;
  singleImageProduct?:any;
}

interface IProps {
  product?: any;
  fullWidth?:any;
  force?:any;
  year?:any;
}

/**
 *
 * ImageScroller component
 * @extends {React.PureComponentReact.Component<IProps,IState>}
 */

class ImageScroller extends React.Component<IProps,IState> {
  public state: IState;

  constructor(props: IProps) {
      super(props);
      this.state = {
        product:this.props.product,
        selectedIndex:1
      };
  }

  public componentDidMount = () => {
    var images = [];
    let prodAssetUrl:string = GenerateProductAssetUrl(this.props.year);
    for (var i = 0; i < 10; i++) {
      images.push(prodAssetUrl+this.props.product.attributes.slug+i+'_500.png');
      if(i == 9){
        this.setState({
          images:images,
          selectedIndex:0
        })
      }
    }
  }
  imageLoaded = (index:any) =>{
    if(index == 0){
      this.setState({
        imageLoaded:true
      })
    }
  }
  removeImage = (index:any) =>{
    if(index == 1){
      this.setState({singleImageProduct:true});
    }
    var images = this.state.images;
    if(images){
      images.splice(index, 1);
      this.setState({
        images:images
      })
    }
  }
  thumbnailClicked = (index:any) => {
    this.setState({
      selectedIndex:index
    })
  }

  public render(): JSX.Element {
    return(
      <div className="product-scroller-wrapper">
        <div className={"product-scroller-container "}>
          {this.state.images && this.state.images.map((image:any,index:any) => {
            return(
                <img
                  ref={"thumbnail"+index}
                  className={"light-grey-background tiny-padding product-scroller-image"}
                  src={image}
                  onLoad={()=>this.imageLoaded(index)}
                  onError={()=>this.removeImage(index)}
                  onClick={()=>this.thumbnailClicked(index)}
                />
            )
          })}
        </div>
        <img className="full-width light-grey-background" src={GeneralAssetUrl+'square.png'} />
      </div>
    )
  }
}

export default ImageScroller;
